import React, { useState } from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import {
  Table,
  SortingIcon,
  TableFilterFromToOld,
  ProgressBar,
  Company,
  EmptyState,
  DateTime,
  Loading
} from 'components/common/Elements/Elements.js';

import { underlineToSpace, moneyFormater } from 'utils/common';
import { tableConf } from '../../helpers/configurates';
import { useRegionalLink } from 'hooks/useRegionalLink';

import classes from './FeaturesAdoptionTable.module.scss';

const FeaturesAdoptionTable = ({
  tableData,
  handleSortable,
  direction,
  fieldName,
  loader,
  ...other
}) => {
  let { url } = useRouteMatch();
  const [row, setRow] = useState('');
  const generateRegionalPath = useRegionalLink();

  const mouseEnter = e => {
    setRow(e.currentTarget.getAttribute('r'));
  };
  const mouseLeave = () => {
    setRow('');
  };

  return (
    <div>
      <Table className={classes.table}>
        <Table.Header>
          <Table.Row withBorder={false}>
            {tableConf.map(({ isSortable, field, title, fromToGroup }, ind) => (
              <Table.HeaderCell
                key={field}
                className={classes.headerCell}
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                r={`r${ind}`}
                title={title}
              >
                {fromToGroup && (
                  <TableFilterFromToOld {...other} field={field} />
                )}
                {isSortable && (
                  <SortingIcon
                    direction={direction}
                    field={field}
                    fieldName={fieldName}
                    onClick={handleSortable(field)}
                  />
                )}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        {loader || (tableData && tableData.length === 0) ? (
          <Table.Body></Table.Body>
        ) : (
          tableData && (
            <Table.Body>
              {tableData.map(company => (
                <Table.Row key={company.customerId}>
                  <Table.Cell
                    className={cn(
                      classes.tableCell,
                      row === 'r0' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    <NavLink
                      to={generateRegionalPath(
                        `${url}/${company.customerId}/environment`
                      )}
                    >
                      <Company
                        nameCompany={
                          company.companyName
                            ? company.companyName
                            : company.customerId
                        }
                        status={company.status}
                        description={company.companySize}
                        recordType={company.source}
                        country={company.country}
                        domain={company.website}
                        customerId={company.customerId}
                      />
                    </NavLink>
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.tableCell,
                      row === 'r1' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    <ProgressBar
                      is={company.tmUtilized}
                      of={company.tmLicenses}
                    />
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.tableCell,
                      row === 'r2' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {`${company.psUtilized}/${company.psLicenses}`}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.tableCell,
                      row === 'r3' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {company.plan ? company.plan : 'NA'}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.tableCell,
                      row === 'r4' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {company.billingCycle
                      ? underlineToSpace(company.billingCycle)
                      : 'NA'}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.tableCell,
                      row === 'r5' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {moneyFormater(company.arr)}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.tableCell,
                      row === 'r6' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    <DateTime date={company.firstPaymentDate} />
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.tableCell,
                      row === 'r7' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {company.industry ? company.industry : 'NA'}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.tableCell,
                      row === 'r8' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {company.accountManager ? company.accountManager : 'NA'}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.tableCell,
                      row === 'r9' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {company.customerSuccessEngineer
                      ? company.customerSuccessEngineer
                      : 'NA'}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          )
        )}
      </Table>

      {loader ? (
        <Loading />
      ) : (
        tableData && tableData.length === 0 && <EmptyState />
      )}
    </div>
  );
};

FeaturesAdoptionTable.propTypes = {
  tableData: PropTypes.arrayOf(object),
  direction: PropTypes.number,
  fieldName: PropTypes.string,
  handleSortable: PropTypes.func,
  loader: PropTypes.bool
};

export default FeaturesAdoptionTable;
